export default "__VITE_ASSET__GUZTJ8rL__"